function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Loading } from '../../Loading';
import { Results } from './partials';
import { Result } from './Result';
import { EmptyResults } from './EmptyResults';
export var ProductsContainer = function (_React$Component) {
  _inherits(ProductsContainer, _React$Component);
  var _super = _createSuper(ProductsContainer);
  function ProductsContainer() {
    var _this;
    _classCallCheck(this, ProductsContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      products: [],
      fetching: false,
      fetched: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleResultClick", function (product) {
      _this.props.onChange(product);
    });
    return _this;
  }
  _createClass(ProductsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props = this.props,
        type = _this$props.type,
        productType = _this$props.productType;
      this.setState({
        fetching: true
      });
      if (type === 'lastViewed') {
        finectAPI({
          version: 'v4',
          path: "users/me/viewed/products",
          method: 'GET',
          onError: function onError() {
            _this2.setState({
              products: [],
              fetched: true,
              fetching: false
            });
          },
          onSuccess: function onSuccess(_ref) {
            var data = _ref.data;
            _this2.setState({
              products: data.filter(function (item) {
                return item.subtype === productType.apiSubtype && item.entity.name;
              }),
              fetched: true,
              fetching: false
            });
          }
        });
      }
      if (type === 'subscriptions') {
        finectAPI({
          version: 'v4',
          path: "users/me/subscriptions?type=product",
          method: 'GET',
          onError: function onError() {
            _this2.setState({
              products: [],
              fetched: true,
              fetching: false
            });
          },
          onSuccess: function onSuccess(_ref2) {
            var data = _ref2.data;
            _this2.setState({
              products: data.filter(function (item) {
                return item.subtype === productType.apiSubtype && item.entity.name;
              }),
              fetched: true,
              fetching: false
            });
          }
        });
      }
      if (type === 'mostViewed') {
        finectAPI({
          version: 'v4',
          path: "products/collectives/".concat(productType.api, "/viewed?interval=week&limit=20"),
          method: 'GET',
          onSuccess: function onSuccess(_ref3) {
            var data = _ref3.data;
            var normalized = data.map(function (item) {
              return {
                subtype: productType.apiSubtype,
                entity: item
              };
            });
            _this2.setState({
              products: normalized,
              fetched: true,
              fetching: false
            });
          }
        });
      }
      if (type === 'sameManagementCompany' && this.props.initialProduct && this.props.initialProduct.managementCompany) {
        finectAPI({
          version: 'v4',
          path: "products/collectives/".concat(productType.api, "?filter=managementCompany/id+eq+'").concat(this.props.initialProduct.managementCompany.id, "'&limit=40"),
          method: 'GET',
          onSuccess: function onSuccess(_ref4) {
            var data = _ref4.data;
            var normalized = data.map(function (item) {
              return {
                subtype: productType.apiSubtype,
                entity: item
              };
            });
            _this2.setState({
              products: normalized,
              fetched: true,
              fetching: false
            });
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props2 = this.props,
        query = _this$props2.query,
        multiple = _this$props2.multiple,
        bag = _this$props2.bag,
        _onSelect = _this$props2.onSelect;
      var _this$state = this.state,
        products = _this$state.products,
        fetching = _this$state.fetching,
        fetched = _this$state.fetched;
      if (fetching) {
        return React.createElement(Loading, {
          height: 120
        });
      }
      var filtered = products.filter(function (item) {
        return item.entity.name.toLowerCase().indexOf(query.toLowerCase()) >= 0;
      });
      if (filtered.length === 0 && products.length > 0) {
        return React.createElement(EmptyResults, null);
      }
      if (fetched && !products.length) {
        return React.createElement(EmptyResults, null);
      }
      return React.createElement(Results, null, filtered.map(function (product, index) {
        var additionalProps = multiple ? {
          onSelect: function onSelect() {
            _onSelect(product);
          },
          isChecked: Boolean(bag.find(function (item) {
            return item.entity.id === product.entity.id;
          }))
        } : {};
        return React.createElement(Result, _extends({
          compact: _this3.props.compact,
          key: index,
          result: product,
          onClick: function onClick() {
            _this3.handleResultClick(product);
          }
        }, additionalProps));
      }));
    }
  }]);
  return ProductsContainer;
}(React.Component);
_defineProperty(ProductsContainer, "defaultProps", {
  compact: false
});